import React, { ReactNode, useEffect, useState } from "react"
import { Button } from "../Button"
import { BackIcon } from "../Icons";
import { Box } from "@mui/material";
import { vars } from "../Variables";
import { Text } from "../Typography";

const {
  primaryColor,
  stepperBg
} = vars;

type step = {
  id: string | number;
  title: string;
  active: boolean;
  isCurrent: boolean;
}

type backObj = {
  icon?: ReactNode;
  label?: string
}

interface IBack {
  onClick: () => void;
  steps?: step[];
  back?: backObj;
}

export const Back: React.FC<IBack> = ({
  onClick,
  steps,
  back = {
    icon: <BackIcon style={{ marginRight: 8 }} />,
    label: 'Back'
  }
}) => {
  const [currentStep, setCurrentStep] = useState<any>(null);

  useEffect(() => {
    const step = steps?.find(step => step.isCurrent);
    setCurrentStep(step)
  }, [steps])

  const style = {
    p: 0,
    minWidth: 0,

    '&:hover': {
      backgroundColor: 'transparent'
    },
  }
  return (
    <>
      <Button
        variant="text"
        disableRipple
        onClick={onClick}
        sx={style}
      >
        {back.icon}{back.label}
      </Button>

      {steps && (
        <>
          <Box gap={0.5} display='flex' mt={1.25} mb={2.5}>
            {steps?.map((step: step) => {
              return (
                <Box
                  width={63}
                  height={5}
                  key={step.id}
                  sx={{
                    backgroundColor: step.active ? primaryColor : stepperBg
                  }}
                />
              )
            })}
          </Box>
          <Text variant="body2">
            {currentStep?.title}
          </Text>
        </>
      )}
    </>
  )
}